<template>
	<div class="root">
		<TableBlock ref="tableData" @checkVal="selectTableBtn" :columns="cloumn" :action="action" :param="param" :navHeight="305">
			<div class="common-space-between">
				<div class="common-items-center">
					<InputBlock title="IMEI" :showBlock="true" :width="150">
						<el-input v-model="param.serialNo" onkeyup='value=value.replace(/^\s*|\s*$/g,"")'
							:size="this.$store.state.btnSize" placeholder="请输入IMEI"></el-input>
					</InputBlock>
					<InputBlock title="是否安装" :width="100">
						<el-select v-model="param.hasBingding" placeholder="请选择是否安装" :size="this.$store.state.btnSize">
							<el-option v-for="item in this.$store.state.conText.installType" :key="item.val"
								:label="item.title" :value="item.val" />
						</el-select>
					</InputBlock>
					<InputBlock title="是否离线" :width="100">
						<el-select v-model="param.status" placeholder="请选择是否离线" :size="this.$store.state.btnSize">
							<el-option v-for="item in this.$store.state.conText.lineType" :key="item.val"
								:label="item.title" :value="item.val" />
						</el-select>
					</InputBlock>
					<span class="title-key" style="margin-right: 3px;">所在地</span>
					<ProvCty ref="codeAddress" width="120px" @getVal="getAddress"></ProvCty>

				</div>
			</div>
			<div class="common-items-center" style="margin-top: 10px;">
				<InputBlock title="平台 " :width="120">
					<el-select v-model="param.belongToPlatform" placeholder="请选择" @change="selectBtn" :size="this.$store.state.btnSize">
						<el-option v-for="item in belongToPlatformOption" :key="item.id" :label="item.label"
							:value="item.id" />
					</el-select>
				</InputBlock>
				
			<el-select
			  style="width: 150px;margin-right: 10px;"
			  v-model="cumId"
			  filterable
			  remote
			  @change="setReceiver"
			  reserve-keyword
			  placeholder="请输入关键词"
			  :loading="loading">
			  <el-option
			    style="width: 255px;"
			    v-for="item in receiverOption"
			    :key="item.id"
			    :label="item.name"
			    :value="item.id">
			  </el-option>
			</el-select>
				<el-button class="btn-heigth" type="primary" icon="el-icon-search" :size="this.$store.state.btnSize"
					@click="searchBtn">搜索</el-button>
				<el-button class="btn-heigth" type="danger" icon="el-icon-refresh" :size="this.$store.state.btnSize"
					@click="resetBtn">重置</el-button>
			</div>
			<el-button class="btn-heigth" style="position: absolute;top: 15px;right: 16px;" type="primary" :size="this.$store.state.btnSize"
					@click="exportBtn">导出</el-button>
		</TableBlock>

	</div>
</template>
<script>
	import { api, operate } from '@/utils/config'
	import { columns } from './index.js'
	import { exportFun } from '@/utils/httpFun'
	import Month from '@/components/component-block/block-month.vue'
	import ProvCty from '@/components/component-provinces/index.vue'
    import { getFun } from '@/utils/httpFun'
	export default {
		components: {
			Month: Month,
			ProvCty
		},
		data() {
			return {
				cloumn: [],
				listData: {},
				action: operate.PRODUCTJINKONG,
				param: {
					serialNo: null,
					hasBingding: null,
					status: null,
					keyWords: null,
					agentId:null,
					factoryId:null
				},
				cumId:'',
				belongToPlatform:"",
				receiverOption: [],
				belongToPlatformOption: [
					{
						id: '2',
						label: '工厂',
						staff: []
					},
					{
						id: '3',
						label: '代理商',
						staff: []
					}
				],
				selectTable:[]
			};
		},
		created() {
			this.cloumn = columns(this);
		},
		mounted() {
		},
		methods: {
			getAddress(ev) {
				console.log('或', ev)
			
				let arr = ev.map(e=>e.name);

				this.param.keyWords = arr.join(',')
			},
			searchBtn() {
				this.$refs.tableData.getDatas()
			},
			resetBtn() {
				this.$refs.codeAddress.clear()
				this.param.serialNo = null;
				this.param.hasBingding = null;
				this.param.status = null;
				this.param.belongToPlatform = null;
				this.param.factoryId = null;
				this.param.agentId = null;
				this.param.keyWords = null;
				this.cumId = null;
				this.$refs.tableData.resetHttp()
			},
			setReceiver(ev){
				this.cumId = ev;
				this.belongToPlatform == 2?this.param.factoryId = ev:this.param.agentId = ev;
			},
			selectBtn(ev) {
				console.log('测试',ev)
				this.belongToPlatform = ev;
				this.getReceiverId(ev)
				// this.resetBtn()
			},
			// 查询相关平台数据
			getReceiverId(){	
				getFun(operate.GETPLATFORMUSER+'/'+this.belongToPlatform,{},res=>{
				  this.receiverOption = res.data;
				})
			
			},
			//导出
			exportBtn(){
					let ids = this.selectTable.map(item=>item.id);
					this.param.deviceIds = ids;
			    exportFun(api.Operate+"/deviceManager/exportDeviceDetailList",this.param,"设备状态信息")
			},
			selectTableBtn(ev){
				console.log('========',ev)
				this.selectTable = ev;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.type {
		font-family: PingFangSC-Regular;
		font-size: 16px;
		color: rgb(19, 21, 26);
		font-weight: 400;
		margin-top: 10px;
	}
	::v-deep .el-select .el-input__inner{
		height: 32px !important;
	}
</style>